<template>
  <div class="registration-page">
    <div class="section section--white-background">
      <div class="registration-page__logo">
        <img src="../assets/logo.svg" alt="mobilistics">
      </div>
      <div class="section__waves section__waves--green"></div>
    </div>
    <div class="section section--green-background">
      <div class="registration-page__head">
        <h2 class="registration-page__headline">{{locale.register.headline}}</h2>
        <div class="registration-page__progress">
          <Progress :steps=this.steps :active=this.activeStep />
        </div>
      </div>
      <div class="registration-page__content">
        <router-view @activeStep="setActiveStep" @responseData="setResponseData" :responseData="responseData"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Progress from './Progress'

export default {
  name: 'Register',
  components: { Progress },
  computed: mapState([
    'locale'
  ]),
  data: function () {
    return {
      steps: [
        {
          name: 'User information'
        },
        {
          name: 'Payment information'
        },
        {
          name: 'Confirmation'
        }
      ],
      activeStep: 0,
      responseData: []
    }
  },
  methods: {
    setActiveStep (activeStep) {
      this.activeStep = activeStep
    },
    setResponseData (responseData) {
      this.responseData = responseData
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue